<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <p>Realizar Pago</p>
  <button mat-mini-fab (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content appPerfectScrollbar>
  <p>Seleccione la tarjeta para realizar el cargo</p>

  <ng-container *ngFor="let payment of tarjetas">
    <div class="payment-source" [ngClass]="{'active': tarjetaActiva === payment.id}" (click)="tarjetaActiva = payment.id">
        <div class="content-icons-text">
            <ng-container [ngSwitch]="payment.card.brand">
                <img *ngSwitchCase="'mastercard'" src="assets/images/icons/icon-met-pago-mastercard.svg" alt="mastercard">
                <img *ngSwitchCase="'visa'" src="assets/images/icons/icon-met-pago-visa.svg" alt="visa">
                <img *ngSwitchCase="'american_express'" src="assets/images/icons/icon-met-pago-amex.svg" alt="amex">
                <img *ngSwitchDefault src="assets/images/icons/icon-met-pago-visa.svg" alt="visa">
            </ng-container>
            <p>•••• •••• •••• {{ payment.card.last4 }} {{ getIsPrincipal(payment.id) ? '(principal)' : ''}}</p>
        </div>
        
        <mat-icon *ngIf="tarjetaActiva === payment.id">done</mat-icon>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button color="primary" (click)="close()">Cancelar</button>
  <button mat-button (click)="submit()" color="accent">Confirmar</button>
</mat-dialog-actions>